// Shown when someone reaches a page their account does not include.
//
// It names the exact permission that was missing, so the employee can tell the
// owner precisely what to grant rather than saying "it does not work".

import { Link, useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useAuthStore } from '../stores/authStore';
import { landingPathFor } from '../routes/navigation';

export function UnauthorizedPage() {
  const { t } = useI18n();
  const location = useLocation();
  const permissions = useAuthStore((state) => state.permissions);
  const status = useAuthStore((state) => state.status);

  useDocumentTitle(t.errors.forbiddenTitle);

  const state = location.state as { permission?: string; from?: string } | null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page px-4">
      <div className="card w-full max-w-md p-7 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-burgundy-red/10 text-burgundy-red">
          <Lock className="h-7 w-7" aria-hidden="true" />
        </div>

        <h1 className="text-lg font-semibold text-ink">{t.errors.forbiddenTitle}</h1>
        <p className="mt-2 text-sm text-ink-muted">{t.errors.forbiddenBody}</p>

        {state?.permission ? (
          <p className="numeric mt-4 rounded-control border border-line bg-surface-soft px-3 py-2 text-xs text-ink-muted">
            {state.permission}
          </p>
        ) : null}

        <Link
          to={status === 'authenticated' ? landingPathFor(permissions) : '/login'}
          className="btn-primary mt-6 w-full"
        >
          {status === 'authenticated' ? t.errors.goToStart : t.errors.signInAgain}
        </Link>
      </div>
    </div>
  );
}
